module.exports = __webpack_public_path__ + "src/assets/Asset 1.svg";